import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ga4PageView } from "@/lib/ga4";

/** Sends a GA4 page view on every route change. */
export default function GA4RouteTracker() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    void ga4PageView(pathname + search);
  }, [pathname, search]);
  return null;
}
